import * as styles from './MenuDefaultLogo.module.css'

import ExpandedLogo from '../../../icons/logo.svg'
import CollapsedLogo from '../../../icons/logo-idwell.svg'

function MenuDefaultLogo({
  className = styles.MenuDefaultLogo,
  collapsed = false,
  iconClassName = styles.icon,
}) {
  return (
    <div className={className}>
      {collapsed ? (
        <CollapsedLogo className={iconClassName} />
      ) : (
        <ExpandedLogo className={iconClassName} />
      )}
    </div>
  )
}

export default MenuDefaultLogo
